import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Safe14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.41603 9.62405L7.00001 7.9014L9.58398 9.62405L10.416 8.37598L7.75 6.59862V4H6.25V6.59863L3.58398 8.37598L4.41603 9.62405Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.35714 1.25C1.74568 1.25 1.25 1.74568 1.25 2.35714V11.6429C1.25 12.2543 1.74568 12.75 2.35714 12.75H11.6429C12.2543 12.75 12.75 12.2543 12.75 11.6429V2.35714C12.75 1.74568 12.2543 1.25 11.6429 1.25H2.35714ZM2.75 11.25V2.75H11.25V11.25H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Safe14.displayName = 'Safe14';
export default Safe14;
